const DataActionTypes = {
    GET : 'GET',
    PAGINATE : 'PAGINATE',
    MANUAL_REFRESH:'MANUAL_REFRESH',
    AUTO_REFRESH:'AUTO_REFRESH',
    CREATE:'CREATE',
    GET_RESET:'GET_RESET',
    UPDATE:'UPDATE'
};

export default DataActionTypes;


// WEBPACK FOOTER //
// ./src/app/data/actions/types/DataActionTypes.js